import $axios from './api';

export const createQuiz = async (payload) => {
	const { data } = await $axios.post('/v1/author/quiz/create', payload);
	return data;
};

export const quizList = async (payload) => {
	const { data } = await $axios.post('/v1/author/quiz/list', payload);
	return data;
};

export const quizById = async (id) => {
	const { data } = await $axios.get(`/v1/author/quiz/${id}`);
	return data;
};

export const updateQuiz = async (id, payload) => {
	const { data } = await $axios.post(`/v1/author/quiz/${id}`, payload);
	return data;
};

export const removeQuiz = async (id) => {
	const { data } = await $axios.delete(`/v1/author/quiz/${id}`);
	return data;
};

export const createQuestion = async ({ quizId, payload })  => {
	const { data } = await $axios.post(`/v1/author/quiz/${quizId}/question/create`, payload);
	return data;
}; 

export const updateQuestion = async ({ quizId, questionId, payload }) => {
	const { data } = await $axios.post(`/v1/author/quiz/${ quizId }/question/${questionId}`, payload);
	return data;
};

export const removeQuestion = async ({ quizId, questionId }) => {
	const { data } = await $axios.delete(`/v1/author/quiz/${ quizId }/question/${questionId}`);
	return data;
};

export const createOptions = async ({ quizId, questionId, payload }) => {
	const { data } = await $axios.post(`/v1/author/quiz/${ quizId }/question/${questionId}/option/create`, payload);
	return data;
};

export const updateOption = async ({ quizId, questionId, optionId, payload }) => {
	const { data } = await $axios.post(`/v1/author/quiz/${quizId}/question/${questionId}/option/${optionId}`, payload);
	return data;
};

export const removeOption = async ({ quizId, questionId, optionId }) => {
	const { data } = await $axios.delete(`/v1/author/quiz/${quizId}/question/${questionId}/option/${optionId}`);
	return data;
};

export const getAnswerList = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/quiz/answers/list', payload);
	return data;
};

export const answerCheck = async (payload) => {
	const { data } = await $axios.post('/v1/author/quiz/answers/check', payload);
	return data;
};

export const getAnswerAttachmentLink = async (answerId, attachmentId) => {
	// Бэкенд возвращает 302 редирект на S3 URL
	// Axios автоматически следует редиректу, нам нужен финальный URL
	const response = await $axios.get(`/v1/author/quiz/answers/${answerId}/attachment/${attachmentId}/link`, {
		maxRedirects: 0, // Не следуем редиректу автоматически
		validateStatus: (status) => status === 302 || status === 200 // Принимаем 302 как успех
	});
	
	// Получаем URL из заголовка Location
	const redirectUrl = response.headers.location || response.request.responseURL;
	return { url: redirectUrl };
};